
export default {
  // Navigation
  home: 'Inicio',
  services: 'Servicios',
  about: 'Nosotros',
  gallery: 'Galería',
  contact: 'Contacto',
  admin: 'Admin',
  getQuote: 'Cotización Gratis',
  
  // Hero Section
  heroTitle: 'Servicios Profesionales de Pintura en Atlanta',
  heroSubtitle: 'Calidad y Experiencia en la que Puedes Confiar',
  heroDescription: 'Transforma tu propiedad con nuestros servicios expertos de pintura interior y exterior. Usamos con orgullo pinturas premium Sherwin Williams para resultados duraderos.',
  heroInteriorTitle: 'Transforma tus Espacios Interiores',
  heroInteriorSubtitle: 'Servicios Premium de Pintura Interior',
  heroInteriorDescription: 'Crea impresiones hermosas y duraderas con nuestros servicios expertos de pintura interior usando pinturas Sherwin Williams de alta calidad.',
  heroCommercialTitle: 'Excelencia en Pintura Comercial',
  heroCommercialSubtitle: 'Servicios Comerciales Profesionales',
  heroCommercialDescription: 'Mejora tu propiedad comercial con nuestros servicios integrales de pintura y mantenimiento comercial.',
  
  // Services
  servicesTitle: 'Nuestros Servicios',
  servicesSubtitle: 'Soluciones Completas de Pintura para Propiedades Residenciales y Comerciales',
  interiorPainting: 'Pintura Interior',
  exteriorPainting: 'Pintura Exterior',
  drywall: 'Drywall y Carpintería',
  pressureWashing: 'Lavado a Presión',
  epoxyFloor: 'Piso Epóxico',
  deckStaining: 'Tinción de Terrazas',
  
  // About
  aboutTitle: 'Acerca de WF & Y Painting LLC',
  aboutDescription: 'Con años de experiencia sirviendo el área de Atlanta, estamos comprometidos a brindar servicios excepcionales de pintura con atención al detalle y satisfacción del cliente.',
  
  // Contact
  contactTitle: 'Obtén tu Estimado Gratuito',
  contactSubtitle: '¿Listo para transformar tu espacio? ¡Contáctanos hoy!',
  phone: 'Teléfono',
  email: 'Correo',
  name: 'Nombre Completo',
  message: 'Detalles del Proyecto',
  submit: 'Enviar Mensaje',
  
  // Footer
  footerDescription: 'Servicios profesionales de pintura en Atlanta, Georgia. Trabajo de calidad y satisfacción del cliente garantizada.',
  allRightsReserved: 'Todos los derechos reservados.',
  
  // Common
  learnMore: 'Saber Más',
  viewGallery: 'Ver Galería',
  callNow: 'Llamar Ahora',
  emailUs: 'Enviar Email',
  
  // Additional Services Page Content
  interiorPaintingDesc: 'Servicios profesionales de pintura interior para hogares y negocios. Usamos pinturas premium Sherwin Williams para asegurar resultados hermosos y duraderos que transforman tus espacios interiores.',
  exteriorPaintingDesc: 'Protege y embellece tu propiedad con nuestros servicios expertos de pintura exterior. Pinturas resistentes al clima y técnicas profesionales aseguran que tu inversión esté protegida por años.',
  drywallDesc: 'Servicios completos de reparación de drywall y carpintería para asegurar superficies perfectas para pintar. Desde pequeños parches hasta instalaciones completas de paredes, manejamos todas tus necesidades de preparación.',
  pressureWashingDesc: 'Servicios completos de lavado a presión para limpiar y preparar superficies antes de pintar. Removemos suciedad, moho y pintura vieja para una adhesión y calidad de acabado óptima.',
  epoxyFloorDesc: 'Recubrimientos de piso epóxico duraderos para garajes, sótanos y espacios comerciales. Crea superficies hermosas y fáciles de limpiar que resisten manchas, químicos y desgaste.',
  deckStainingDesc: 'Servicios profesionales de tinción y restauración de terrazas para proteger y mejorar tus espacios exteriores. Extiende la vida de tu terraza mientras mejoras su apariencia.',
  
  // Service Features
  colorConsultation: 'Consulta de colores',
  surfacePreparation: 'Preparación de superficies',
  premiumPaintApplication: 'Aplicación de pintura premium',
  cleanupIncluded: 'Limpieza incluida',
  weatherResistantPaints: 'Pinturas resistentes al clima',
  powerWashingIncluded: 'Lavado a presión incluido',
  trimAndDetailWork: 'Trabajo de molduras y detalles',
  multiYearWarranty: 'Garantía de varios años',
  holeAndCrackRepair: 'Reparación de agujeros y grietas',
  textureMatching: 'Igualación de texturas',
  customCarpentry: 'Carpintería personalizada',
  surfaceSmoothing: 'Alisado de superficies',
  highPressureCleaning: 'Limpieza de alta presión',
  mildewRemoval: 'Remoción de moho',
  ecoFriendlySolutions: 'Soluciones ecológicas',
  chemicalResistant: 'Resistente a químicos',
  easyToClean: 'Fácil de limpiar',
  slipResistantOptions: 'Opciones antideslizantes',
  customColorsAvailable: 'Colores personalizados disponibles',
  woodRestoration: 'Restauración de madera',
  uvProtection: 'Protección UV',
  waterResistance: 'Resistencia al agua',
  naturalWoodEnhancement: 'Realce de madera natural',
  
  // Process Section
  ourProcess: 'Nuestro Proceso',
  processDescription: 'Seguimos un proceso comprobado para asegurar resultados excepcionales en cada proyecto',
  consultation: 'Consulta',
  consultationDesc: 'Estimado gratuito y planificación del proyecto',
  preparation: 'Preparación',
  preparationDesc: 'Preparación de superficies y protección',
  application: 'Aplicación',
  applicationDesc: 'Aplicación profesional de pintura',
  completion: 'Finalización',
  completionDesc: 'Inspección final y limpieza',
  
  // About Page Content
  ourStory: 'Nuestra Historia',
  storyParagraph1: 'Fundada en 2009, WF & Y Painting LLC comenzó como un pequeño negocio familiar con una misión simple: brindar a los propietarios de viviendas y negocios de Atlanta servicios excepcionales de pintura en los que puedan confiar. Lo que comenzó como una operación de una persona ha crecido hasta convertirse en una empresa de pintura de servicio completo que sirve al área metropolitana de Atlanta.',
  storyParagraph2: 'Nuestro compromiso con la calidad del trabajo, el servicio confiable y la satisfacción del cliente nos ha ganado una reputación como uno de los contratistas de pintura más confiables de Atlanta. Nos enorgullecemos de usar solo pinturas y materiales premium Sherwin Williams, asegurando que cada proyecto brinde belleza y protección duraderas.',
  storyParagraph3: 'Hoy, continuamos creciendo mientras mantenemos el toque personal y la atención al detalle que nuestros clientes han llegado a esperar. Cada proyecto, ya sea residencial o comercial, recibe el mismo nivel de cuidado y profesionalismo que nos ha convertido en la empresa de pintura preferida de Atlanta.',
  
  // Values
  ourValues: 'Nuestros Valores',
  valuesDescription: 'Estos valores fundamentales guían todo lo que hacemos y aseguran resultados excepcionales en cada proyecto',
  qualityWorkmanship: 'Trabajo de Calidad',
  qualityWorkmanshipDesc: 'Nos enorgullecemos de entregar resultados excepcionales usando materiales premium y técnicas comprobadas.',
  reliableService: 'Servicio Confiable',
  reliableServiceDesc: 'Finalización a tiempo y comunicación clara durante todo el proyecto.',
  customerSatisfaction: 'Satisfacción del Cliente',
  customerSatisfactionDesc: 'Tu satisfacción es nuestra prioridad. Trabajamos estrechamente contigo para superar las expectativas.',
  licensedAndInsured: 'Licenciado y Asegurado',
  licensedAndInsuredDesc: 'Completamente licenciado y asegurado para tu tranquilidad y protección.',
  
  // Team Section
  meetOurTeam: 'Conoce Nuestro Equipo',
  teamDescription: 'Nuestros profesionales experimentados están dedicados a entregar resultados excepcionales en cada proyecto',
  founderAndLeadPainter: 'Fundador y Pintor Principal',
  williamDescription: 'Con más de 15 años de experiencia, William fundó WF & Y Painting para brindar a Atlanta servicios excepcionales de pintura.',
  projectManager: 'Gerente de Proyecto',
  carlosDescription: 'Carlos asegura que cada proyecto funcione sin problemas de principio a fin, coordinando todos los aspectos de nuestros servicios de pintura.',
  colorConsultant: 'Consultora de Colores',
  mariaDescription: 'María ayuda a los clientes a elegir los colores y acabados perfectos para transformar sus espacios hermosamente.',
  
  // Certifications
  certificationsAndPartnerships: 'Certificaciones y Asociaciones',
  certificationsDescription: 'Mantenemos los más altos estándares a través de certificaciones profesionales y asociaciones de calidad',
  sherwinWilliamsPartner: 'Socio Sherwin Williams',
  sherwinWilliamsDesc: 'Socio certificado usando pinturas y materiales premium Sherwin Williams para resultados superiores.',
  licensedAndInsuredTitle: 'Licenciado y Asegurado',
  licensedAndInsuredCertDesc: 'Completamente licenciado y asegurado para tu protección y tranquilidad en cada proyecto.',
  bbbAccredited: 'Acreditado BBB',
  bbbAccreditedDesc: 'Acreditado por Better Business Bureau con calificación A+ por servicio al cliente excepcional.',
  
  // Contact Page
  sendUsAMessage: 'Envíanos un Mensaje',
  yourFullName: 'Tu nombre completo',
  yourEmail: 'tu@correo.com',
  serviceNeeded: 'Servicio Necesario',
  selectAService: 'Selecciona un servicio',
  tellUsAboutProject: 'Cuéntanos sobre tu proyecto...',
  charactersLimit: 'caracteres',
  sending: 'Enviando...',
  contactInformation: 'Información de Contacto',
  weRespondWithin24Hours: 'Respondemos dentro de 24 horas',
  serviceArea: 'Área de Servicio',
  surroundingAreas: 'y áreas circundantes',
  needImmediateHelp: '¿Necesitas Ayuda Inmediata?',
  urgentNeedsDescription: 'Para necesidades urgentes de pintura o reparaciones de emergencia, llámanos directamente.',
  
  // Success/Error Messages
  messageSuccessTitle: '¡Gracias! Tu mensaje ha sido enviado exitosamente. Te contactaremos pronto.',
  messageErrorTitle: 'Lo siento, hubo un error enviando tu mensaje. Por favor intenta de nuevo o llámanos directamente.',
  
  // CTA Sections
  readyToGetStarted: '¿Listo para Comenzar?',
  contactUsToday: 'Contáctanos hoy para tu estimado gratuito y consulta',
  readyToWorkWithUs: '¿Listo para Trabajar con Nosotros?',
  experienceTheDifference: 'Experimenta la diferencia WF & Y Painting en tu próximo proyecto',
  
  // Schedule and Hours
  monSat7am6pm: 'Lun-Sáb: 7AM-6PM',
  
  // Stats
  yearsExperience: 'Años de Experiencia',
  projectsCompleted: 'Proyectos Completados',
  
  // Reviews Section
  reviewsTitle: 'Lo Que Dicen Nuestros Clientes',
  reviewsSubtitle: 'Lee testimonios de clientes satisfechos en Atlanta que confían en WF & Y Painting para sus necesidades de pintura',
  reviewsCompleted: 'Proyectos Completados',
  reviewsRating: 'Calificación Promedio',
  reviewsSatisfaction: 'Satisfacción del Cliente',
  
  // Individual Reviews
  review1Text: '¡WF & Y Painting transformó completamente nuestra sala! La atención al detalle fue increíble y terminaron exactamente a tiempo. William y su equipo fueron profesionales, limpios, y la calidad superó nuestras expectativas.',
  review1Service: 'Pintura Interior - Sala y Cocina',
  
  review2Text: 'Excelente trabajo de pintura exterior en nuestra casa de dos pisos. El equipo fue puntual, respetuoso, e hizo un trabajo de preparación excelente. Nuestra casa se ve como nueva y la calidad de la pintura es de primera.',
  review2Service: 'Pintura Exterior - Casa Completa',
  
  review3Text: 'Servicio profesional de principio a fin. María nos ayudó a elegir los colores perfectos y el equipo de pintura fue meticuloso. Protegieron todos nuestros muebles y dejaron todo impecable. ¡Trabajo increíble!',
  review3Service: 'Pintura Interior - Dormitorio Principal',
  
  review4Text: '¡La mejor compañía de pintura en Atlanta! Pintaron nuestro edificio de oficinas y los resultados son fantásticos. Excelente comunicación, precios justos, y mano de obra superior. Definitivamente los usaremos de nuevo.',
  review4Service: 'Pintura Comercial - Edificio de Oficinas',
  
  review5Text: 'Carlos y el equipo hicieron un trabajo increíble en los gabinetes y paredes de nuestra cocina. ¡La transformación es impresionante! Fueron limpios, eficientes, y la calidad es excepcional. Vale cada centavo.',
  review5Service: 'Pintura de Gabinetes de Cocina',
  
  review6Text: 'Excelente servicio de reparación de drywall y pintura. Arreglaron todas las grietas y agujeros perfectamente antes de pintar. No se puede notar que alguna vez hubo daño. Verdaderos profesionales que se enorgullecen de su trabajo.',
  review6Service: 'Reparación de Drywall y Pintura Interior',
  
  // New property added
  writeReview: 'Escribir una Reseña'
};
